import moment from 'moment'
import { saveAs } from 'file-saver'
import json2csv from 'json2csv'

const getHeaderKeys = (startDateStr, totalDays) => {
  const currentDate = moment(startDateStr).add(-1, 'days')
  const dates = []
  for (let j = 0; j < totalDays; j++) {
    dates.push(currentDate.add(1, 'days').format('ddd DD'))
  }
  let allKeys = ['Name', 'Job', 'Line Item']
  allKeys = allKeys.concat(dates)
  allKeys.push('Total')
  return allKeys
}

const getJobTypeRow = (startDateStr, totalDays, jobsTotals, jobType, name) => {
  const currentDate = moment(startDateStr).add(-1, 'days')
  const totalsRow = {}
  totalsRow['Name'] = name
  totalsRow['Job'] = `${jobType} Jobs Total`
  let total = 0
  // Add install jobs totals
  for (let j = 0; j < totalDays; j++) {
    const key = currentDate.add(1, 'days').format('ddd DD')
    totalsRow[key] = jobsTotals[j]
    total += jobsTotals[j]
  }
  totalsRow['Total'] = total
  return totalsRow
}

const getPayrollRow = (startDateStr, totalDays, payrollTotals, name) => {
  const currentDate = moment(startDateStr).add(-1, 'days')
  const payrollRow = {}
  payrollRow['Name'] = name
  payrollRow['Job'] = 'Payroll Hours'
  let total = 0
  // Add install jobs totals
  for (let j = 0; j < totalDays; j++) {
    const key = currentDate.add(1, 'days').format('ddd DD')
    payrollRow[key] = payrollTotals[j]
    total += payrollTotals[j]
  }
  payrollRow['Total'] = total
  return payrollRow
}

const getAllJobsTotalsRow = (installTotalsRow, serviceTotalsRow, maintenanceTotalsRow) => {
  const totalsRow = {}
  totalsRow['Name'] = installTotalsRow['Name']
  totalsRow['Job'] = 'Total'
  for (const key in installTotalsRow) {
    if (key !== 'Name' && key !== 'Job') {
      totalsRow[key] = installTotalsRow[key] + serviceTotalsRow[key] + maintenanceTotalsRow[key]
    }
  }
  return totalsRow
}

const getRatioRow = (allJobsRow, payrollRow) => {
  const ratioRow = {}
  ratioRow['Name'] = payrollRow['Name']
  ratioRow['Job'] = 'Ratio'
  for (const key in allJobsRow) {
    if (key !== 'Name' && key !== 'Job') {
      if (payrollRow[key]) {
        ratioRow[key] = (100 * allJobsRow[key] / payrollRow[key]).toFixed(1)
      }
      else {
        ratioRow[key] = 0
      }
    }
  }
  return ratioRow
}

const getLineItemsRows = (tableData) => {
  const result = []
  for (const lineItemJob of tableData.lineItemsJobs) {
    const lineItemRow = {}
    lineItemRow['Name'] = tableData.name
    lineItemRow['Job'] = lineItemJob.jobName
    lineItemRow['Line Item'] = lineItemJob.lineItem
    const currentDate = moment(tableData.startDateStr).add(-1, 'days')
    let itemTotal = 0
    for (let j = 0; j < tableData.totalDays; j++) {
      const key = currentDate.add(1, 'days').format('ddd DD')
      lineItemRow[key] = lineItemJob.times[j]
      itemTotal += lineItemJob.times[j]
    }
    lineItemRow['Total'] = itemTotal
    result.push(lineItemRow)
  }
  return result
}

const getTableData = tableData => {
  const installTotalsRow = getJobTypeRow(tableData.startDateStr, tableData.totalDays, tableData.installJobsTotals, 'Install', tableData.name)
  const serviceTotalsRow = getJobTypeRow(tableData.startDateStr, tableData.totalDays, tableData.serviceJobsTotals, 'Service', tableData.name)
  const maintenanceTotalsRow = getJobTypeRow(tableData.startDateStr, tableData.totalDays, tableData.maintenanceJobsTotals, 'Recurrent', tableData.name)
  const allJobsTotalsRow = getAllJobsTotalsRow(installTotalsRow, serviceTotalsRow, maintenanceTotalsRow)
  const payrollRow = getPayrollRow(tableData.startDateStr, tableData.totalDays, tableData.payrollInfo, tableData.name)
  // Add line items jobs
  const tableDataResult = getLineItemsRows(tableData)
  // Add jobs totals
  tableDataResult.push(installTotalsRow)
  tableDataResult.push(serviceTotalsRow)
  tableDataResult.push(maintenanceTotalsRow)
  tableDataResult.push(allJobsTotalsRow)
  // Add payroll and ratio rows
  tableDataResult.push(payrollRow)
  tableDataResult.push(getRatioRow(allJobsTotalsRow, payrollRow))  
  return tableDataResult
}

const getJobsData = tablesData => {
  let result = []
  for (const tableData of tablesData) {
    if (result.length > 0) {
      // Blank line between each workers
      result.push([])
    }
    result = result.concat(getTableData(tableData))
  }
  return result
}

const getEndDateStr = (startDateStr, totalDays) => {
  const date = moment(startDateStr)
  return date.add(totalDays, 'days').format('YYYY-MM-DD')
}

const TimeAllocationExporter = {

  exportCsv: tablesData => {
    if (tablesData && tablesData.length > 0) {
      const headerKeys = getHeaderKeys(tablesData[0].startDateStr, tablesData[0].totalDays)
      const data = getJobsData(tablesData)
      const result = json2csv({ data, fields: headerKeys })
      const blob = new Blob([result], {type: 'text/csv;charset=utf-8'})
      // TODO: Include date & time in the file name
      const nameDateInfo = `${tablesData[0].startDateStr}-${getEndDateStr(tablesData[0].startDateStr, tablesData[0].totalDays)}`
      const filename = `timeAllocationReport-${nameDateInfo}.csv`
      saveAs(blob, filename)
    }
  }

}

export default TimeAllocationExporter



// WEBPACK FOOTER //
// ./src/reports/common/TimeAllocationExporter.js